import React from 'react';
import { Modal, ModalBody } from 'reactstrap';

interface VoidTicketModalProps {
  isOpen: boolean;
  toggle: () => void;
  onVoid: (ticketId: string | number) => void;
  ticketId: string | number;
}

const VoidTicketModal = ({ isOpen, toggle, onVoid, ticketId }: VoidTicketModalProps) => {
  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      className="void-ticket-modal"
      centered
    >
      <ModalBody className="void-ticket-modal-body">
        <h2 className="void-ticket-title">Void Ticket</h2>
        <p className="void-ticket-message">Do you want to void ticket?</p>
        <div className="void-ticket-actions">
          <button 
            className="void-ticket-button void-ticket-button-close" 
            onClick={toggle}
          >
            Close
          </button>
          <button 
            className="void-ticket-button void-ticket-button-void" 
            onClick={() => {
              onVoid(ticketId);
              toggle();
            }}
          >
            Void
          </button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default VoidTicketModal;
